module.exports = __webpack_public_path__ + "static/19-e87377c680fbcee382c5c50ec0aa68a7.jpg";